import React from "react";
import * as Styled from "../style";

export const CustomInput = ({ value, placeholder, onClick, formatDate }) => {
  return (
    <Styled.SelectBut
      onClick={e => {
        e.preventDefault();
        onClick();
      }}
      className="date-box-button"
    >
      {value ? formatDate(value) : placeholder}
    </Styled.SelectBut>
  );
};
